import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'
import styled from 'styled-components'
import getGatsbyImage from 'utils/getGatsbyImage'

const Wrapper = styled.div`
  min-height: 255px;
  background-color: #FFF2DA;
  display: flex;
`

const Content = styled.div`
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  > * { flex: 1; width: 100%; height: 100%; }
  @media (max-width: 930px) {
    flex-direction: column;
    > :first-child {
      max-width: 400px;
      padding-bottom: 10%;
      margin: 0 auto
    }
  }
`

const Quote = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px 0px;
  max-width: 400px;
  margin: 0px auto;
  padding-left: 30px;
  line-height: 1.2;
  > :first-child {
    content: "";
    font-size: 1.8rem;
    top: 0px;
    left: 0px;
    font-weight: bold;
  }
  > :last-child {
    margin-top: 15px;
    align-self: flex-end;
    font-weight: bold;
  }
`

interface IProps {
  image: any,
  text: string,
  author: {
    name: string,
    title: string
  }
}

const QuoteHero = (props: IProps) => <Wrapper>
    <Content>
      <GatsbyImage image={getGatsbyImage(props.image.localFile)} alt={props.author.name} />
      <Quote>
        <div>“</div>
        <div>{props.text}</div>
        <div>{props.author.name}</div>
      </Quote>
    </Content>
  </Wrapper>

export default QuoteHero
